import { ComponentFactoryResolver, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'getObjectValuesPipe' })
export class GetObjectValuesPipe implements PipeTransform {
  transform(itemList:any[],exludedKeys:any[]) {
      
    itemList.forEach(item => {
        exludedKeys.forEach(keyName => {
            delete item[keyName];
        });
    });
    
    return  itemList.map(item => Object.values(item));
  }
}



@Pipe({ name: 'contactPreferenceValuePipe' })
export class ContactPreferenceValuePipe implements PipeTransform {
  transform(contactPreference:string,contcat:any) {
    let contactpref:string = "";
      if(contactPreference == "email"){
        contactpref = contcat.email;
      }else if(contactPreference == "mobile"){
        contactpref= contcat.mobileNo;
      }else if(contactPreference == "Phone1"){
        contactpref = contcat.phone1;
      }else if(contactPreference == "phone2"){
        contactpref = contcat.phone2;
      }else if(contcat.mobileno != null){
        contactpref= contcat.mobileno;
      }else if(contcat.email != null){
        contactpref= contcat.email;
      }else if(contcat.phone1 != null){
        contactpref= contcat.phone1;
      }else if(contcat.phone2 != null){
        contactpref= contcat.phone2;
      }

      return contactpref;
  
  }
}


// @Pipe({ name: 'formatColumHeaderValuePipe' })
// export class FormatColumHeaderValuePipe implements PipeTransform {
//   transform(itemList:string[]) {
//     return  itemList.map(item => item.replace(/([A-Z])/g, ' $1').trim());
//   }
// }


@Pipe({ name: 'consigneeAddressCompletePipe' })
export class ConsigneeAddressCompletePipe implements PipeTransform {
  transform(address1:string,consignee:any) {
    let address:string 
    if(consignee.consigneeAddrCode){
      address =  "[" + consignee.consigneeAddrCode + "] " + address1;
    }else{
      address = address1;
    }
    
    if(consignee){
      if(consignee.consigneeId != 0){
        address = address + ", " + consignee.address2 + ", " + consignee.address3 + ", " + consignee.cityDesc + " - " + consignee.pinCode;
        address = address + ", " + consignee.stateDesc;
      }
    }
    
      return address;
  
  }
}



@Pipe({ name: 'replaceNullOrUndefinedPipe' })
export class ReplaceNullOrUndefinedPipe implements PipeTransform {
  transform(text:string) {
    
    if(text == undefined || text == null || text.trim() == "" ){
      return "";
    }else{
      return text;
    }
      
  
  }
}




@Pipe({ name: 'addSlashInDatePipe' })
export class AddSlashInDatePipe implements PipeTransform {
  transform(text:string) {
    let day:any = null;
    let month:any = null;
    let year:any = null;

    if(text){
    if(text.length == 2){
      day = text;     
    }else if(text.length == 5){
      let textSplit = text.split("/");
      day = textSplit[0];
      month = textSplit[1];      
    }    
  }
  return {year:year,month:month,day:day};
  
  }
}